import { useEffect } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function AuthCallback() {
    useEffect(() => {
        const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
        const sessionId = params.get("session_id");
        if (!sessionId) {
            window.location.replace("/admin/dossiers");
            return undefined;
        }
        let cancelled = false;
        fetch(`${BACKEND_URL}/api/auth/session`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ session_id: sessionId }),
        })
            .then((response) => {
                if (!response.ok) throw new Error("Unable to sign in");
                return response.json();
            })
            .then(() => {
                if (!cancelled) window.location.replace("/admin/dossiers");
            })
            .catch(() => {
                if (!cancelled) window.location.replace("/admin/dossiers?auth=error");
            });
        return () => { cancelled = true; };
    }, []);

    return <div className="passport-loading" data-testid="passport-auth-callback">Connexion sécurisée en cours…</div>;
}
